import { css } from '@emotion/css';
import {
  Y200, N400, Y400, N700,
} from '../../../../components/Colors';

export const PageStyle = css`
    margin-top: 3rem;
    .text-center {
        text-align: center;
    }
    .margin-auto {
        margin: auto;
    }
    .btn-ubah {
        background-color: ${Y200};
        color: ${N400};
        border-color: ${Y200};
        box-shadow: 1px 3px 5px #888888;
    }
    .btn-kembali {
        background-color: ${Y400};
        border-color: ${Y400};
        color: ${N700};
        box-shadow: 1px 3px 5px #888888;
    }

    #img-detail {
        width: auto;
        height: auto;
        max-height: 400px;
        max-width: 100%;
    }
`;
